/**
 * Locale-aware label from { tr, en } JSON or plain string.
 */
export const localizedJsonText = (value, locale = 'tr', fallback = '') => {
  if (value == null) return fallback;
  if (typeof value === 'string') return value || fallback;
  if (typeof value !== 'object') return String(value);

  const lang = String(locale || 'tr').slice(0, 2);
  const primary = value[lang];
  if (typeof primary === 'string' && primary.trim()) return primary;

  const secondary = lang === 'tr' ? value.en : value.tr;
  if (typeof secondary === 'string' && secondary.trim()) return secondary;

  const first = Object.values(value).find((v) => typeof v === 'string' && v.trim());
  return typeof first === 'string' ? first : fallback;
};
